import * as React from 'react';
import createSvgIcon from './utils/createSvgIcon';
export default createSvgIcon( /*#__PURE__*/React.createElement("path", {
  d: "M6 2v6h.01L6 8.01 10 12l-4 4 .01.01H6V22h12v-5.99h-.01L18 16l-4-4 4-3.99-.01-.01H18V2H6z"
}), 'HourglassFullOutlined');


//////////////////
// WEBPACK FOOTER
// ./~/@material-ui/icons/esm/HourglassFullOutlined.js
// module id = 4176
// module chunks = 2